import { Endpoint } from '../endpoint';
import { LibraryDocumentResponse, LibraryDocumentId } from '@business/entities/libraryDocument';

export function fetchForms() {
  return Endpoint.get<LibraryDocumentResponse[]>(`@gc/library-document`);
}

export function fetchForm(id: LibraryDocumentId) {
  return Endpoint.get<LibraryDocumentResponse>(`@gc/library-document/form/${id}`);
}

export function createForm(data: Partial<LibraryDocumentResponse>) {
  return Endpoint.post<LibraryDocumentResponse>(`@gc/library-document`, { data });
}

export function updateForm(id: LibraryDocumentId, data: Partial<LibraryDocumentResponse>) {
  return Endpoint.patch<LibraryDocumentResponse>(`@gc/library-document/${id}`, { data });
}

export function deleteForm(id: LibraryDocumentId) {
  return Endpoint.delete<void>(`@gc/library-document/${id}`);
}

export function duplicateForm(id: LibraryDocumentId, data: Partial<LibraryDocumentResponse>) {
  return Endpoint.post<LibraryDocumentResponse>(`@gc/library-document/duplicate/${id}`, { data });
}

export function saveFormFields(id: LibraryDocumentId, data: Pick<LibraryDocumentResponse, 'fields'>) {
  return Endpoint.post<LibraryDocumentResponse>(`@gc/library-document/save-fields/${id}`, { data });
}
